import React from 'react';
import '../styles/GenerationStatusIndicator.css';

function GenerationStatusIndicator({ isGenerating, currentChapters, totalChapters }) {
    if (!isGenerating) return null;

    // Show indicator even if we don't know total yet
    const displayText = totalChapters > 0
        ? `Generating chapters... ${currentChapters}/${totalChapters}`
        : `Generating chapters... ${currentChapters}`;

    return (
        <div className="generation-status-indicator">
            <div className="status-pulse"></div>
            <span className="status-text">
                {displayText}
            </span>
        </div>
    );
}

export default GenerationStatusIndicator;
